import { SESSION_STORAGE_KEY_AUTH_SHORTCUT_DISMISSED } from '@lib/core/service/consts';

export const AuthShortcutSession = {
  isDismissed: () => sessionStorage.getItem(SESSION_STORAGE_KEY_AUTH_SHORTCUT_DISMISSED) === 'true',
  reset: () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY_AUTH_SHORTCUT_DISMISSED);
  },
  setDismissed: () => {
    sessionStorage.setItem(SESSION_STORAGE_KEY_AUTH_SHORTCUT_DISMISSED, 'true');
  },
};
